export default "__VITE_ASSET__6JhPhIXi__"